// extracted by mini-css-extract-plugin
module.exports = {"root":"v_M","caption":"v_bt d_q","imageShadow":"v_bv"};